const SCROLL_DELTA_THRESHOLD = 10
const SCROLL_HIDE_OFFSET = 100

export default {
  data() {
    return {
      isScrollHidden: false,
    }
  },
  mounted() {
    this._lastScrollY = window.scrollY
    this._ticking = false
    window.addEventListener('scroll', this._handleScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._handleScroll)
  },
  methods: {
    _handleScroll() {
      if (!this._ticking) {
        requestAnimationFrame(this._updateScrollDirection)
        this._ticking = true
      }
    },
    _updateScrollDirection() {
      const currentScrollY = window.scrollY
      if (Math.abs(currentScrollY - this._lastScrollY) < SCROLL_DELTA_THRESHOLD) {
        this._ticking = false
        return
      }
      if (currentScrollY > this._lastScrollY && currentScrollY > SCROLL_HIDE_OFFSET) {
        if (!this.isScrollHidden) this.isScrollHidden = true
      } else if (currentScrollY < this._lastScrollY) {
        if (this.isScrollHidden) this.isScrollHidden = false
      }
      this._lastScrollY = currentScrollY
      this._ticking = false
    },
  },
}
